import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import computers from './modules/computers'
import statuses from './modules/statuses'
import currencies from './modules/currencies'
import cards from './modules/cards'
import gpus from './modules/gpus'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        computers,
        statuses,
        currencies,
        gpus,
        cards,
    },
    plugins: [createPersistedState()],
})
